/**
 * Created by intellicar-rinas on 9/10/17.
 */
import React, {Component} from 'react';
import './TripDetailsWidget.css'; 
import moment from 'moment';
import _ from 'lodash';
const format = 'DD.MM.YYYY HH:mm a';
 

class Img extends Component {
    state = { loading: true }
    render() {
        return <div>
            <img src={this.props.src} onLoad={e => this.setState({loading: false})} />
            {this.state.loading && <div className="ldg"><div></div></div>}
        </div>
    }
}

class TripDetailsWidget extends Component{

    resume(){
        if(!this.mounted) return;
        if(this.props.resume && this.props.resume.state){
            this.setState({...this.props.resume.state}, ()=>{
                this.refs.search.value = this.props.resume.state.searchInput;
                this.searchInputChanged();
            });
        }else{
            this.setState({body:[], busy:false}, ()=>{
                this.refs.search.value = "";
                this.searchInputChanged();
            });
        }
    }
 
    state = {
        data: []
    }

    setData(data=[], keepState=false){
        this.setState({data});
    };

    setBusy(status){
        if(!this.mounted) return;
        this.setState({
            busy:status
        })
    }
 
    saveState(prevProps){
        if(!prevProps.saveState)
            return;
        prevProps.saveState(this.state, prevProps.schemaKey, this.props.data);
    }

    componentDidUpdate(prevProps) {
        this.saveState(prevProps);
    }

    componentWillUnmount(){
        this.mounted = false;
        this.saveState(this.props);
    }

    getDetails =(item, index)=> {
        let ti = item.tripmeta;
        return (
            <div className='tdw-card' key={index}>

            <div className="t-details">
                <h1>#{ti.salesOrder}</h1>
                <div className="t-hds">
                    <div>
                        <label>Distance (km)</label>
                        <div>{parseInt(_.get(item, 'tripdistance') || 0, 10)}</div>
                    </div>
                    <div>
                        <label>Fuelused (ltr)</label>
                        <div>{parseInt(_.get(item, 'fuelused') || 0, 10)}</div>
                    </div>
                    <div>
                        <label>Mileage (kmpl)</label>
                        <div>{item.mileage}</div>
                    </div>
                    <div>
                        <label>CPK (₹)</label>
                        <div>{item.cpk}</div>
                    </div>
                    <div>
                        <label>Fuel Price</label>
                        <div>{item.fuelprice}</div>
                    </div>
                    <div>
                        <label>Avg Speed</label>
                        <div>{parseInt(_.get(item, 'avgspeed') || 0, 10)}</div>
                    </div>
                    <div>
                        <label>Start Odo</label>
                        <div>{parseInt(_.get(item, 'startodo') || 0, 10)}</div>
                    </div>
                    <div>
                        <label>End Odo</label>
                        <div>{parseInt(_.get(item, 'endodo') || 0, 10)}</div>
                    </div>
                </div>
                <div className="t-bxs">
                    <Img src={ti.driverPhoto} />
                    <Img src={ti.truckPhoto} />
                </div>
                <div className="t-dtc">
                    <h2>Trip Details</h2>
                    <table>
                        <tbody>
                            <tr>
                                <td>Customer Name</td>
                                <td>{_.get(ti, 'tripDetails.customerName')}</td>
                            </tr>
                            <tr>
                                <td>Reference Party</td>
                                <td>{_.get(ti, 'tripDetails.referenceParty')}</td>
                            </tr>
                            <tr>
                                <td>Truck License Number</td>
                                <td>{_.get(ti, 'tripDetails.truckLicenseNumber')}</td>
                            </tr>
                            <tr>
                                <td>Truck Number of Wheels</td>
                                <td>{_.get(ti, 'tripDetails.truckNumberOfWheels')}</td>
                            </tr>
                            <tr>
                                <td>LR Number</td>
                                <td>{_.get(ti, 'tripDetails.LRNumber')}</td>
                            </tr>
                            <tr>
                                <td>Driver Name</td>
                                <td>{_.get(ti, 'tripDetails.driverName')}</td>
                            </tr>
                            <tr>
                                <td>Driver Phone Number</td>
                                <td>{_.get(ti, 'tripDetails.driverPhoneNumber')}</td>
                            </tr>
                            <tr>
                                <td>Pickup Location</td>
                                <td>{_.get(ti, 'tripDetails.pickupLocation.place')}</td>
                            </tr>
                            <tr>
                                <td>Drop Location</td>
                                <td>{_.get(ti, 'tripDetails.dropLocation.place')}</td>
                            </tr>
                        </tbody>
                    </table>
                    <h2>Time</h2>
                    <table>
                        <tbody>
                            <tr>
                                <td>Time of Entry</td>
                                <td>{moment(_.get(ti, 'time.entry')).format(format)}</td>
                            </tr>
                            <tr>
                                <td>Time of Gross Weight</td>
                                <td>{moment(_.get(ti, 'time.grossWeight')).format(format)}</td>
                            </tr>
                            <tr>
                                <td>Time of Exit</td>
                                <td>{moment(_.get(ti, 'time.exit')).format(format)}</td>
                            </tr>
                            <tr>
                                <td>Time of Started</td>
                                <td>{moment(_.get(ti, 'time.started')).format(format)}</td>
                            </tr>
                            <tr>
                                <td>Time of Completed</td>
                                <td>{moment(_.get(ti, 'time.completed')).format(format)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="t-dtc">
                    {/* <h2>Duration</h2>
                    <table>
                        <tbody>
                            <tr>
                                <td>Loading Duration</td>
                                <td>{duration(_.get(ti, 'duration.loading'))}</td>
                            </tr>
                            <tr>
                                <td>Exit Gate Duration</td>
                                <td>{duration(_.get(ti, 'duration.exitGate'))}</td>
                            </tr>
                            <tr>
                                <td>Inside Gate Duration</td>
                                <td>{duration(_.get(ti, 'duration.insideGate'))}</td>
                            </tr>
                            <tr>
                                <td>Transit</td>
                                <td>{duration(_.get(ti, 'duration.transit'))}</td>
                            </tr>
                        </tbody>
                    </table> */}
                    <h2>Load Details</h2>
                    <table>
                        <tbody>
                            <tr>
                                <td>Passing Weight</td>
                                <td>{_.get(ti, 'loadDetails.passingWeight')}</td>
                            </tr>
                            <tr>
                                <td>Load Carrying</td>
                                <td>{_.get(ti, 'loadDetails.loadCarrying')}</td>
                            </tr>
                            <tr>
                                <td>Tare Weight</td>
                                <td>{_.get(ti, 'loadDetails.tareWeight')}</td>
                            </tr>
                            <tr>
                                <td>Gross Weight</td>
                                <td>{_.get(ti, 'loadDetails.tareWeight')}</td>
                            </tr>
                            <tr>
                                <td>Unloaded Quantity</td>
                                <td>{_.get(ti, 'loadDetails.unloadedQuantity')}</td>
                            </tr>
                            <tr>
                                <td>Material</td>
                                <td>{_.get(ti, 'loadDetails.material')}</td>
                            </tr>
                        </tbody>
                    </table>
                    <h2>Truck Owner Details</h2>
                    <table>
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{_.get(ti, 'truckOwnerDetails.name')}</td>
                            </tr>
                            <tr>
                                <td>Number</td>
                                <td>{_.get(ti, 'truckOwnerDetails.phoneNumber')}</td>
                            </tr>
                            <tr>
                                <td>Address</td>
                                <td>{_.get(ti, 'truckOwnerDetails.address')}</td>
                            </tr>
                            <tr>
                                <td>Transporter Name</td>
                                <td>{_.get(ti, 'transporterDetails.name')}</td>
                            </tr>
                            <tr>
                                <td>Transporter Phone Number</td>
                                <td>{_.get(ti, 'transporterDetails.phoneNumber')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </div>
        )
    }
 
    render(){
        return(
            <div className="TripDetailsWidget">
                {this.state.data && this.state.data.length ? this.state.data.map(this.getDetails) : ''}
            </div>
        )
    }

}

export default TripDetailsWidget;